import React from 'react';

import { cn } from '@/lib/utils/cn';

type T_SectionProps = {
  children: React.ReactNode;
  className?: string;
  container?: boolean;
  containerClassName?: string;
  style?: React.CSSProperties;
};

export function Section({
  children,
  container,
  containerClassName,
  className = '',
  style
}: T_SectionProps) {
  return (
    <section
      className={cn('md:py-11 max-sm:mb-5 py-7 ', className)}
      style={{ ...style }}
    >
      {container ? (
        <div
          className={cn(
            'container px-4 md:px-0 mx-auto max-w-[var(--container-width)]',
            containerClassName
          )}
        >
          {children}
        </div>
      ) : (
        <React.Fragment>{children}</React.Fragment>
      )}
    </section>
  );
}
